// extracted by mini-css-extract-plugin
export var divider = "_g0-7";
export var itemsToggle = "_g0-8";
export var mergeModal = "_g0-1";
export var optionCard = "_g0-4";
export var radioGroup = "_g0-6";
export var radioOption = "_g0-0";
export var selected = "_g0-5";
export var shipmentOptions = "_g0-2";
export var tableOptions = "_g0-3";